import type {
  MarkEntityViewedBodyDto,
  NotificationCenterContract,
} from '@terra/shared-contracts-notification-center';
import { notificationCenterClient } from '@terra/shared-rest-clients-notification-center';
import type { TargetTypeType } from '@terra/shared-schemas-orchestrator';
import { tenantAwareApiWrapper, withOrchestratorClient } from './portal-http';

export type NotificationCenterTarget = {
  targetType: TargetTypeType;
  targetId: string;
};

export const portalNotificationCenterApi = {
  getTargetNotificationActions: ({
    targetType,
    targetId,
    limit,
  }: NotificationCenterTarget & { limit: number }) =>
    tenantAwareApiWrapper<
      typeof NotificationCenterContract.getApplicationNotificationActions
    >({
      endpointFn: (headers) =>
        notificationCenterClient.getApplicationNotificationActions({
          query: { targetType, targetId, skip: 0, limit },
          ...withOrchestratorClient(headers),
        }),
    }),

  getTargetHealthIssues: ({
    targetType,
    targetId,
    limit,
  }: NotificationCenterTarget & { limit: number }) =>
    tenantAwareApiWrapper<
      typeof NotificationCenterContract.getApplicationNotificationHealthIssues
    >({
      endpointFn: (headers) =>
        notificationCenterClient.getApplicationNotificationHealthIssues({
          query: { targetType, targetId, skip: 0, limit },
          ...withOrchestratorClient(headers),
        }),
    }),

  dismissNotification: ({
    targetType,
    targetId,
    notificationId,
  }: NotificationCenterTarget & { notificationId: string }) =>
    tenantAwareApiWrapper<
      typeof NotificationCenterContract.dismissNotification
    >({
      endpointFn: (headers) =>
        notificationCenterClient.dismissNotification({
          params: { notificationId },
          query: { targetType, targetId },
          ...withOrchestratorClient(headers),
        }),
    }),

  markEntityViewed: ({
    targetType,
    targetId,
    entity,
  }: NotificationCenterTarget & { entity: MarkEntityViewedBodyDto }) =>
    tenantAwareApiWrapper<typeof NotificationCenterContract.markEntityViewed>({
      endpointFn: (headers) =>
        notificationCenterClient.markEntityViewed({
          query: { targetType, targetId },
          body: entity,
          ...withOrchestratorClient(headers),
        }),
    }),
};
